import loader from '../../assets/loader-spinner.gif'

const Loading = () => (
    <div className="loader">
        <img className="loader-image" src={loader} alt="loader" />
    </div>
)


export default Loading
